// Collection card reordering on mobile
let hasReordered = false;

function reorderCollectionCardsOnMobile() {
  const isMobile = window.innerWidth < 1024;

  if (isMobile && !hasReordered) {
    const productGrid = document.querySelector('.product-grid');
    if (!productGrid) return;

    const allItems = Array.from(productGrid.children);
    const products = allItems.filter(item => !item.classList.contains('collection-card-item'));
    const cardsWithPositions = allItems
      .filter(item => item.classList.contains('collection-card-item'))
      .map(card => ({ card, position: allItems.indexOf(card) + 1 }));

    const mobileOrder = [];
    let productIndex = 0;


    while (productIndex < products.length) {
      mobileOrder.push(products[productIndex]);
      if (products[productIndex + 1]) {
        mobileOrder.push(products[productIndex + 1]);
      }
      productIndex += 2;

      cardsWithPositions.forEach(({ card, position }) => {
        if (position <= productIndex && !mobileOrder.includes(card)) {
          mobileOrder.push(card);
        }
      });
    }

    productGrid.innerHTML = '';
    mobileOrder.forEach(element => {
      productGrid.appendChild(element);
    });

    hasReordered = true;
  } else if (!isMobile) {
    hasReordered = false;
  }
}

// Initialize collection card reordering only on collection pages
document.addEventListener('DOMContentLoaded', () => {
  const productGrid = document.querySelector('.product-grid');
  if (productGrid) {
    const mobileMediaQuery = window.matchMedia('(max-width: 1023px)');

    reorderCollectionCardsOnMobile();
    mobileMediaQuery.addEventListener('change', reorderCollectionCardsOnMobile);
  }
});

function attachSwatchListeners() {
  const productCards = document.querySelectorAll(".product-card-wrapper");

  productCards.forEach((card) => {
    const swatches = card.querySelectorAll(".js-swatch");
    const mainImage = card.querySelector("[data-featured-image]");
    if (!mainImage || swatches.length === 0) return;

    const setActiveSwatch = (swatch) => {
      const newImageUrl = swatch.getAttribute("data-img");
      const newProductUrl = swatch.getAttribute("data-url");

      // Update main image
      if (newImageUrl) {
        const template = document.createElement('template');
        template.innerHTML = decodeURIComponent(newImageUrl);
        const img = template.content.querySelector('img');
        mainImage.src = img.src;
        mainImage.srcset = img.srcset;
      }

      // Update all product links in the card
      if (newProductUrl) {
        card.querySelectorAll("a.full-unstyled-link, a.no-underline").forEach((link) => {
          link.setAttribute("href", newProductUrl);
        });
      }

      // Update swatch active state (this card only)
      swatches.forEach((s) => s.classList.remove("current"));
      swatch.classList.add("current");
    };

    swatches.forEach((swatch) => {
      if (swatch.getAttribute("data-initial-variant") === "true") {
        swatches.forEach((s) => s.classList.remove("current"));
        swatch.classList.add("current");
      }
      swatch.addEventListener("click", () => setActiveSwatch(swatch));
    });
  });
}

document.addEventListener("DOMContentLoaded", attachSwatchListeners);
